import { usePublicLang } from "@/contexts/PublicLangContext";
import ScrollReveal from "./ScrollReveal";

// Fix D (2026-09-09): franja con los tres ejes de servicio de la clinica,
// pedida para que se entienda de un vistazo que ofrece SJB. Contenido fijo
// de marca (no depende de datos de la clinica).
const KEYS = ["facial", "body", "coaching"];

export default function ServiceLines() {
  const { t } = usePublicLang();
  return (
    <section className="py-14 md:py-16 px-5" data-testid="landing-service-lines">
      <ScrollReveal className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-center">
        {KEYS.map((k, i) => (
          <div key={k} className="flex items-center gap-6">
            <span className="font-serif text-lg md:text-2xl text-[#292522]">{t(`landing.lines.${k}`)}</span>
            {i < KEYS.length - 1 && <span className="hidden sm:inline w-8 h-px bg-[var(--brand-primary)]" aria-hidden="true" />}
          </div>
        ))}
      </ScrollReveal>
    </section>
  );
}
